import l10n from '../../shared/strings';

// Mirrors the server's batchImport ceiling (app/products/batchImport/requestSchema.js) — the
// hard cap decided for round-trip bulk editing (PCS-11321 decision #7).
export const PRODUCTS_EXPORT_LIMIT = 50000;

// Force-included by the server when present in the export-time schema — listed in the
// "Always included" copy instead of being sent in the request. Parent SKU is omitted for
// product-only selections (PCS-11486).
export const LOCKED_COLUMNS = [
  { key: 'recordId', title: l10n.PRODUCTS_EXPORT_CSV.lockedRecordId },
  { key: 'sku', title: l10n.PRODUCTS_EXPORT_CSV.lockedSku },
  { key: 'parentSku', title: l10n.PRODUCTS_EXPORT_CSV.lockedParentSku },
];

export function getLockedColumns(hasVariants) {
  if (hasVariants) {
    return LOCKED_COLUMNS;
  }
  return LOCKED_COLUMNS.filter((column) => column.key !== 'parentSku');
}
